import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import SectionNextmineLanding from './SectionNextmineLanding';
import { ASSET_NAME } from './LandingPage.duck';
import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { getFeaturedListingsProps } from '../../util/data';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Custom Nextmine landing page (letterpress design), rendered through PageBuilder
// so it keeps the marketplace Topbar and Footer. This overrides the Console-hosted
// landing content on purpose.
const nextmineLandingData = {
  sections: [{ sectionType: 'customNextmine', sectionId: 'nextmine-landing' }],
  meta: {
    pageTitle: { fieldType: 'metaTitle', content: 'Nextmine - pre-loved fine jewelry' },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Buy and resell fine jewelry safely, with secure payments on every sale.',
    },
  },
};

export const LandingPageComponent = props => {
  const { inProgress, error } = props;

  return (
    <PageBuilder
      pageAssetsData={nextmineLandingData}
      options={{
        sectionComponents: {
          customNextmine: { component: SectionNextmineLanding },
        },
      }}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const featuredListingData = state.featuredListings || {};

  const getListingEntitiesById = listingIds => getListingsById(state, listingIds);

  return { pageAssetsData, featuredListingData, getListingEntitiesById, inProgress, error };
};

const mapDispatchToProps = dispatch => ({
  onFetchFeaturedListings: (sectionId, parentPage, listingImageConfig, allSections) =>
    dispatch(fetchFeaturedListings({ sectionId, parentPage, listingImageConfig, allSections })),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LandingPageComponent);

export default LandingPage;
